import { formatMoney } from '@exigo/shared';

export { formatMoney, formatCount, formatPercent, toCents } from '@exigo/shared';

/**
 * A compact form for card faces: "$52K" rather than "$52,000". Rounds to the
 * nearest thousand above $10K, matching the density the SOW-builder cards use.
 */
export function formatMoneyCompact(cents: number | null | undefined): string {
  if (cents === null || cents === undefined || !Number.isFinite(cents)) return '—';
  const dollars = Math.round(cents / 100);
  if (Math.abs(dollars) < 10_000) return formatMoney(cents);
  if (Math.abs(dollars) < 1_000_000) return `$${String(Math.round(dollars / 1000))}K`;
  return `$${(dollars / 1_000_000).toFixed(1)}M`;
}

/** Converts a dollar amount typed into a form field to integer cents. */
export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}

/** The inverse, for populating a number input from stored cents. */
export function centsToDollars(cents: number): number {
  return cents / 100;
}
